/**
 * @generated SignedSource<<28f9dd309da5f279dacfe3275eed25b3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useNowIndexes_teamScheduleEventOccasion$data = ReadonlyArray<{
  readonly startAt: string;
  readonly " $fragmentType": "useNowIndexes_teamScheduleEventOccasion";
}>;
export type useNowIndexes_teamScheduleEventOccasion$key = ReadonlyArray<{
  readonly " $data"?: useNowIndexes_teamScheduleEventOccasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"useNowIndexes_teamScheduleEventOccasion">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "useNowIndexes_teamScheduleEventOccasion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAt",
      "storageKey": null
    }
  ],
  "type": "TeamScheduleEventOccasion",
  "abstractKey": "__isTeamScheduleEventOccasion"
};

(node as any).hash = "db15f6b3a61d940f32262d7bcc38b5fe";

export default node;
